<div class="page-container">
    <div class="flex min-w-0 items-center justify-between gap-4">
      <h1 class="main-heading min-w-0">
        Email Black List Detail
      </h1>
      <app-navpath class="hidden md:block"></app-navpath>
    </div>
    <div class="mb-2 flex w-full flex-col gap-1 md:w-fit md:flex-row">
      <!-- Add -->
      <button *ngIf="mode === 'Add'" class="shorter-btn misc-btn" (click)="onSave()">
        <fa-icon [icon]="faPlus" class="mr-1"></fa-icon>Create
      </button>
  
      <!-- Edit -->
      <button *ngIf="mode === 'Edit'" class="shorter-btn misc-btn" (click)="onSave()">
        <fa-icon [icon]="faPencil" class="mr-1"></fa-icon>Update
      </button>

      <button *ngIf="mode === 'Edit'" class="shorter-btn delete-btn" (click)="onDelete()">
        <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>Delete
      </button>
  
      <!-- Cancel -->
      <button class="shorter-btn clear-btn" (click)="onCancel()">
        <fa-icon [icon]="faBan" class="mr-1"></fa-icon>Cancel
      </button>
    </div>
    <div class="content-container">
        <app-data-form [dataFields]="formFields"></app-data-form>
    </div>
  </div>
